import { Pipe, PipeTransform } from '@angular/core';
import { formatFileSize } from '@qtek/shared/utils';

@Pipe({
  name: 'filesize',
  standalone: true,
})
export class FileSizePipe implements PipeTransform {
  transform(size = 0, precision = 2): string | null {
    return formatFileSize(size, precision);
  }
}
